import type { AccordionItems } from './CheckoutAccordionProvider';

interface GetDefaultExpandedArgs {
  infoValid: boolean;
  optionsValid: boolean;
}

export const getDefaultExpanded = ({
  optionsValid,
  infoValid,
}: GetDefaultExpandedArgs): AccordionItems => {
  if (!optionsValid) {
    return 'options';
  } else if (!infoValid) {
    return 'info';
  } else {
    return 'payments';
  }
};
